import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { authSelector, createWalletEntry } from '../../../store/slices';
import { CreateWalletEntry, IUser, IUserCustomer } from '../../../types';
import { AmountInput } from './inputs';
import { PrimaryButton, SecondaryButton } from './buttons';
import { PrimaryInput } from './inputs';
import { TextArea } from './inputs';
import { SearchUser } from '../search-user';

interface UpdateWalletProps {
  close: () => void;
  user?: IUser;
}

export const UpdateWallet = ({ close, user: preselectedUser }: UpdateWalletProps) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(authSelector);

  const [customer, setCustomer] = React.useState<IUserCustomer | undefined>(
    preselectedUser
      ? {
          id: preselectedUser.id,
          fullName: `${preselectedUser.firstName} ${preselectedUser.lastName}`,
          username: preselectedUser.username,
          phoneNumber: preselectedUser.phoneNumber,
          wallet: preselectedUser.wallet ?? undefined,
        }
      : undefined
  );

  const [payload, setPayload] = React.useState<CreateWalletEntry>({
    amount: 0,
    userId: preselectedUser?.id ?? 0,
    entry: 'DEBIT',
    description: '',
    reference: '',
  });

  React.useEffect(() => {
    setPayload((prev) => ({
      ...prev,
      userId: customer?.id ?? 0,
    }));
  }, [customer]);

  const processTransaction = () => {
    dispatch(createWalletEntry({ payload, cb: close }));
  };

  return (
    <div className="bg-white p-6">
      <p className="bold text-xl">Debit User Wallet</p>

      <SearchUser
        filterWithWallet
        disabled={!!preselectedUser}
        customer={customer}
        setCustomer={setCustomer}
      />

      <div className="h-px w-full bg-neutral-300 my-4" />

      <AmountInput
        value={payload.amount}
        onValueChange={(e) =>
          setPayload({ ...payload, amount: e.floatValue ?? 0 })
        }
      />

      <TextArea
        className="w-full"
        label="Description"
        placeholder="Enter description"
        value={payload.description}
        onChange={(e) =>
          setPayload({ ...payload, description: e.currentTarget.value })
        }
      />

      <div className="h-px w-full bg-neutral-300 my-4" />

      <PrimaryInput
        className="w-full"
        disabled
        label="Initiator name"
        value={`${user.firstName} ${user.lastName}`}
      />

      <div className="flex gap-4 mt-4">
        <PrimaryButton
          text="DEBIT ACCOUNT"
          type="button"
          disabled={!(payload.userId && payload.amount && !!payload.description)}
          onClick={processTransaction}
        />
        <SecondaryButton text="Cancel" type="button" onClick={close} />
      </div>
    </div>
  );
};
